export function UserInfoCard({ label, value, c, dark }) {
  return (
    <div
      style={{
        border: `1px solid ${c.cardBdr}`,
        borderRadius: 10,
        background: c.hover,
        padding: "10px 12px",
        boxShadow: dark ? "none" : "0 1px 2px rgba(0,0,0,.04)",
        minWidth: 0,
      }}
    >
      <div style={{ fontSize: 10, color: c.sub, textTransform: "uppercase", letterSpacing: ".04em" }}>{label}</div>
      <div style={{ marginTop: 6, fontSize: 13, color: c.text, fontWeight: label === "Name" ? 600 : 500, wordBreak: "break-word" }}>
        {value}
      </div>
    </div>
  );
}
